export const permitTypes = state => state.permitTypes.items

export const dobPermitTypes = state => _.filter(state.permitTypes.items, {type: 'dob'})
export const dotPermitTypes = state => _.filter(state.permitTypes.items, {type: 'dot'})

export const permitTypeById = state => id => _.find(permitTypes(state), { id })

export const permitTypeNameById = state => id => {
    let permitType = _.find(permitTypes(state), { id })

    return permitType ? permitType.title : ''
}
